import React, { useContext } from 'react';
import { ItemCount } from '@core-ui/item-count';
import { useLocalize } from '@core-ui/localization-provider';
import { PageDataContext } from '../../providers/page-data-provider/index';

const ItemCountContainer = (): JSX.Element => {
  const { localize } = useLocalize();
  const { productGroups } = useContext(PageDataContext);
  const itemCount = productGroups[0].products.length;

  const ariaLabelText = localize(
    itemCount > 1
      ? 'left_rail.item_count_aria_label_plural'
      : 'left_rail.item_count_aria_label',
    { itemCount }
  );
  const itemCountText = localize(
    itemCount > 1
      ? 'left_rail.item_count_text_plural'
      : 'left_rail.item_count_text',
    { itemCount }
  );

  return (
    <div
      className="item-count-container"
      data-testid="item-count-container"
    >
      <ItemCount
        aria-label={ariaLabelText}
        text={itemCountText}
      />
    </div>
  );
};

export default ItemCountContainer;
